import React from "react";
import { TextInput } from "react-native";
import Label from "../Label";

const TextArea = ({ value, onSubmit, formItem = {} }) => {
  const { label } = formItem;
  return (
    <>
      <Label label={label} />
      <TextInput
        value={value}
        onChangeText={onSubmit}
        style={{
          fontSize: 18,
          borderBottomWidth: 1,
          borderColor: "rgba(0, 0, 0, 0.4)",
          paddingVertical: 0,
        }}
      />
    </>
  );
};

export default TextArea;
